import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TaxillaApiService } from '@encomply-core/services/taxillaapi/taxillaapi.service';
import { Utils } from '@encomply-core/services/utils/utils.service';
import { translate, TRANSLOCO_SCOPE } from '@ngneat/transloco';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { BroadcasterService } from '../../../../../../../third-party/ng-broadcaster/src/broadcaster.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { CommonUtilsService } from '@taxilla-library/lib/services/commonutils/common-utils.service';
import { getAssociatedOrganizationsMap$ } from '@taxilla-library/lib/store/selectors/locations.selector';
import { getCurrentOrganizationId$ } from '@taxilla-library/lib/store/selectors/session.selector';
import { getManageAppsSelectedServices$ } from '@taxilla-library/lib/store/selectors/manage-apps.selector';
import { Organization } from '@taxilla-library/lib/models/organization.class';
import {
    SetManageAppsSelectedServiceIds,
    SubmitManageAppsSelectedServiceIds,
    UpdateSubscribedServices,
    ValidateAndSubscribetoConnector,
    ValidateConnetorSuccessAction,
} from '@taxilla-library/lib/store/actions/manage-apps.actions';
import { UtilsService } from '@taxilla-library/lib/services/utils/utils.service';

@Component({
    selector: 'app-subscribe-asset',
    templateUrl: './subscribe-asset.component.html',
    styleUrls: ['./subscribe-asset.component.scss'],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: '',
        },
    ],
    standalone: false,
})
export class SubscribeAssetComponent implements OnInit {
    public isConnector = false;
    public submitClone: any;
    public requiredFields: { [key: string]: string } = {};
    public filterOrgName = '';
    public filterSubOrgName = '';
    private currentOrgId = '';
    private currentOrgDetails = {};
    public organizationsToRender: any[] = [];
    private allOrgTree = [];
    public associationAction = false;
    private subOrgCheckedList = [];
    public selectedOrganization: Organization = new Organization({});
    private allOrgMap = {};
    public subOrganization = [];
    private allOrgList = [];
    private tempAllOrgList = [];
    public selectAllFlag = false;
    public selectedAssets: {
        assetType: string;
        createdDate: string;
        description: string;
        displayName: string;
        lastModifiedDate: string;
        organizationId: string;
        providerOrgId: string;
        restApiName: string;
        selected: boolean;
        serviceId: string;
        serviceName: string;
        serviceType: string;
        tags: string[];
    }[] = [];
    public selectedAssetsId = [];
    private unsubscribe = new Subject<void>();
    public counts = {
        asset: 0,
        bridge: 0,
        widget: 0,
        recon: 0,
        dashbaord: 0,
        connector: 0,
        package: 0,
    };
    checkedOrganizationsId: any;
    private unSubscribe = new Subject<void>();
    private organizationsMap: { [property: string]: Organization };

    constructor(
        private dialogRef: MatDialogRef<SubscribeAssetComponent>,
        private _Broadcaster: BroadcasterService,
        private _utils: Utils,
        private _taxilla: TaxillaApiService,
        private _libUtils: UtilsService,
        private store$: Store,
        private actions$: Actions
    ) {}

    public closeModal = () => {
        this.store$.dispatch(
            SetManageAppsSelectedServiceIds({
                ids: [],
            })
        );
        this.dialogRef.close();
    };

    public submitUser = () => {
        if (this.subOrgCheckedList.length < 1) {
            this._libUtils.alertError(`${translate('Please select atleast one organization to subscribe')}.`);
            return;
        }

        if (this.submitClone) {
            // If this is a clone connector
            this.submitClone(this.subOrgCheckedList);
            return;
        }

        if (this.isConnector) {
            this.store$.dispatch(
                ValidateAndSubscribetoConnector({
                    resourceName: this.selectedAssetsId[0],
                    orgIds: this.subOrgCheckedList,
                    requiredFields: this.requiredFields || {},
                })
            );
        } else {
            this.store$.dispatch(
                SubmitManageAppsSelectedServiceIds({
                    ids: this.selectedAssetsId,
                    orgIds: this.subOrgCheckedList,
                })
            );
        }
    };

    public clearSearchSubOrg = () => {
        this.filterSubOrgName = '';
    };

    private getOrgDetails = org => {
        this.allOrgList = [];
        this.tempAllOrgList = [];
        this.allOrgMap = {};
        this.allOrgTree = [];
        this.organizationsToRender = [];
        this.filterOrgName = '';
        this.selectedOrganization = new Organization({});
        this.subOrganization = [];
        this.filterSubOrgName = '';
        this.associationAction = false;
        this.subOrgCheckedList = [];
        this.getAllOrganizationList(org);
    };

    private getAllOrganizationList = org => {
        this._taxilla.organization.getOrganizationChildHierarchy(org.id).subscribe(res => {
            const organizationNodes = (res && res.orgNodes) || [];
            const organizations = [];
            this.pushToList(organizationNodes, organizations);
            this.allOrgList = organizations.slice(0);
            this._Broadcaster.broadcast('getParentOrgList', this.allOrgList);
            this.tempAllOrgList = this.allOrgList;
            for (let i = 0; i < 2; i++) {
                this.generateOrganizationNodeHierarchy();
            }
            this.generateOrganizationDisplayNames();
            if (this.allOrgTree && this.allOrgTree.length > 0) {
                this.organizationsToRender = CommonUtilsService.cloneObject(this.allOrgTree);
            } else {
                this.checkTenatandSubTenantStructure();
            }
            this.associationAction = true;
        });
    };

    private pushToList = (nodes: OrganizationNode[], organizationsList: Organization[]) => {
        nodes.forEach(node => {
            organizationsList.push(node.organization);
            if (node.nextNodes) {
                this.pushToList(node.nextNodes, organizationsList);
            }
        });
    };

    private checkTenatandSubTenantStructure = () => {
        if (this.tempAllOrgList && this.tempAllOrgList.length > 0) {
            if (this.organizationsToRender.length < 1) {
                const parentObj = CommonUtilsService.cloneObject(this.tempAllOrgList[0].parent);
                this.tempAllOrgList.push(parentObj);
                this.generateOrganizationNodeHierarchy();
                this.generatePartnerTenantNodeHierarchy();
                this.generateOrganizationDisplayNames();
                if (this.allOrgTree && this.allOrgTree.length > 0) {
                    this.organizationsToRender = CommonUtilsService.cloneObject(this.allOrgTree);
                } else {
                    this.checkTenatandSubTenantStructure();
                }
            }
        }
    };

    private generatePartnerTenantNodeHierarchy = () => {
        for (let i = this.tempAllOrgList.length - 1; i >= 0; i -= 1) {
            const tenant = this.tempAllOrgList[i];
            if (tenant.parent) {
                let lastParent = tenant.parent;
                while (lastParent.parent) {
                    if (this.allOrgMap[lastParent.id]) {
                        lastParent = lastParent.parent;
                    } else {
                        const parentNode = this.createPartnerNode(lastParent);
                        this.addToMap(parentNode);
                        lastParent = lastParent.parent;
                    }
                }
                if (!this.allOrgMap[lastParent.id]) {
                    const node = this.createPartnerNode(lastParent);
                    this.addToMap(node);
                    this.allOrgTree = this.allOrgTree || [];
                    if (!this.isNodePresentInTree(node, this.allOrgTree)) {
                        this.allOrgTree.push(node);
                    }
                }
                this.allOrgMap[lastParent.id] && this.allOrgMap[lastParent.id].nextNodes.push(tenant.id);
                this.tempAllOrgList.splice(i, 1);
            }
        }
    };

    private isNodePresentInTree = (node, tree) => {
        if (!node || !tree || !tree.length) {
            return;
        }
        let isPresent = false;
        for (let i = 0; i < tree.length; i++) {
            if (tree[i].id === node.id) {
                isPresent = true;
                break;
            }
        }
        return isPresent;
    };

    private createPartnerNode = (org?) => {
        if (!org) {
            return;
        }
        const partnerNode = this._utils.createNode(org);
        partnerNode.isPartnerOrg = true;
        return partnerNode;
    };

    private addToMap = (node?) => {
        if (!node) {
            return;
        }
        if (!this.allOrgMap) {
            this.allOrgMap = {};
        }
        this.allOrgMap[node.id] = node;
    };

    private generateOrganizationNodeHierarchy = () => {
        for (let i = this.tempAllOrgList.length - 1; i >= 0; i -= 1) {
            const org = this.tempAllOrgList[i];
            let node;
            if (this.allOrgMap && this.allOrgMap[org.id]) {
                node = this.allOrgMap[org.id];
            } else {
                node = this._utils.createNode(org);
                this.addToMap(node);
            }
            if (!org.parent) {
                this.allOrgTree = this.allOrgTree || [];
                this.allOrgTree.push(node);
                this.tempAllOrgList.splice(i, 1);
            } else {
                if (this.allOrgMap[org.parent.id]) {
                    this.allOrgMap[org.parent.id].nextNodes.push(org.id);
                    this.tempAllOrgList.splice(i, 1);
                } else {
                }
            }
        }
    };

    private generateOrganizationDisplayNames = () => {
        for (const organization in this.allOrgMap) {
            this.allOrgMap[organization].displayTenantName = this._utils.getOrganizationName(this.allOrgMap[organization]);
        }
    };

    checkedOrganizations = event => {
        this.checkedOrganizationsId = event;
    };

    selectOrganization = (organization?: Organization) => {
        const element = document.querySelector('.mat-pseudo-checkbox');
        element?.classList.remove('mat-pseudo-checkbox-checked');
        this.selectAllFlag = false;
        if (!organization) {
            return;
        }
        this.subOrganization = [];
        this.subOrgCheckedList = [];
        this.selectedOrganization = new Organization(organization || {});
        this.organizationPreOrderTraversal(organization);
    };

    private organizationPreOrderTraversal = (organization?) => {
        if (!organization) {
            return;
        }
        this.subOrganization = this.subOrganization || [];
        if (this.checkIfParent(organization, this.currentOrgDetails)) {
            this.subOrganization.push(organization);
        }
        if (!organization.nextNodes || organization.nextNodes.length === 0) {
            organization.nextNodes = this.allOrgMap[organization.id] && this.allOrgMap[organization.id].nextNodes;
        }
        if (organization.nextNodes) {
            for (let i = 0; i < organization.nextNodes.length; i++) {
                this.organizationPreOrderTraversal(this.allOrgMap[organization.nextNodes[i]]);
            }
        }
    };

    private checkIfParent = (organization, currentOrg) => {
        if (!currentOrg || !currentOrg.parent) {
            return true;
        }
        if (currentOrg.parent.id === organization.id) {
            return false;
        }
        return this.checkIfParent(organization, currentOrg.parent);
    };

    public checkedChanged = (event, checkList?) => {
        let isExist = false;
        if (event) {
            if (this.subOrgCheckedList.length > 0) {
                for (let i = 0; i < this.subOrgCheckedList.length; i++) {
                    if (this.subOrgCheckedList[i] === event) {
                        isExist = true;
                        this.subOrgCheckedList.splice(i, 1);
                        break;
                    }
                }
                if (!isExist) {
                    this.subOrgCheckedList.push(event);
                }
            } else {
                if (event !== undefined) {
                    this.subOrgCheckedList.push(event);
                }
            }
        }
        this.checkIfAllChecked(checkList);
    };

    private checkIfAllChecked = checkList => {
        const totalSubOrgLength = this.subOrganization && this.subOrganization.length;
        let checkedCount = 0;
        checkList.selectedOptions.selected.find(obj => {
            if (obj.value === undefined) {
                checkedCount--;
            } else {
                checkedCount++;
            }
        });
        if (totalSubOrgLength === checkedCount) {
            this.selectAllFlag = true;
        } else {
            this.selectAllFlag = false;
        }
    };

    public selectAll = (checkList?) => {
        this.selectAllFlag = !this.selectAllFlag;
        if (this.selectAllFlag) {
            checkList.selectAll();
            this.subOrganization &&
                this.subOrganization.map(sub => {
                    if (sub.id) {
                        this.subOrgCheckedList.push(sub.id);
                    }
                });
        } else {
            checkList.deselectAll();
            this.subOrgCheckedList = [];
        }
    };

    public removeApp = app => {
        this.store$.dispatch(
            SetManageAppsSelectedServiceIds({
                ids: this.selectedAssets
                    .filter(service => service.serviceId !== app.serviceId)
                    .reduce((serviceIds, service) => {
                        serviceIds.push(service.serviceId);
                        return serviceIds;
                    }, []),
            })
        );
    };

    public checkForAppSelection = () => {
        if (this.selectedAssets.length < 1) {
            if (this.subOrgCheckedList.length < 1) {
                return true;
            }
            return false;
        } else {
            if (this.selectedAssetsId.length < 1 || this.subOrgCheckedList.length < 1) {
                return true;
            } else {
                return false;
            }
        }
    };

    public trackById = (_index: number, item: any) => {
        return item.id;
    };

    ngOnInit(): void {
        this.store$
            .select(getCurrentOrganizationId$)
            .pipe(
                takeUntil(this.unSubscribe),
                filter(data => data !== undefined)
            )
            .subscribe(orgId => {
                this.currentOrgId = orgId;
            });
        this.store$
            .select(getAssociatedOrganizationsMap$)
            .pipe(
                takeUntil(this.unSubscribe),
                filter(data => data !== undefined)
            )
            .subscribe(orgsMap => {
                this.organizationsMap = CommonUtilsService.cloneObject(orgsMap);
                this.currentOrgDetails = Object.values(this.organizationsMap).find(org => org.id === this.currentOrgId);
            });
        this.store$
            .select(getManageAppsSelectedServices$)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(asset => {
                this.selectedAssetsId = [];
                this.selectedAssets = CommonUtilsService.cloneObject(asset);
                this.counts = {
                    asset: this.selectedAssets.filter(service => service.serviceType === 'ASSET').length,
                    bridge: this.selectedAssets.filter(service => service.serviceType === 'BRIDGE_ASSET').length,
                    widget: this.selectedAssets.filter(service => service.serviceType === 'WIDGET').length,
                    recon: this.selectedAssets.filter(service => service.serviceType === 'RECON').length,
                    dashbaord: this.selectedAssets.filter(service => service.serviceType === 'DASHBOARD').length,
                    connector: this.selectedAssets.filter(service => service.serviceType === 'CONNECTOR').length,
                    package: this.selectedAssets.filter(service => service.serviceType === 'PACKAGE').length,
                };
                asset?.forEach(assetObj => {
                    if (assetObj.assetType === 'CONNECTOR') {
                        this.selectedAssetsId.push(assetObj.restApiName);
                    } else {
                        this.selectedAssetsId.push(assetObj.serviceId);
                    }
                });
            });
        this.actions$
            .pipe(ofType(UpdateSubscribedServices))
            .pipe(
                takeUntil(this.unsubscribe),
                filter(data => data?.ids?.length > 0)
            )
            .subscribe(() => {
                this.closeModal();
            });
        this.actions$
            .pipe(ofType(ValidateConnetorSuccessAction))
            .pipe(
                takeUntil(this.unsubscribe),
                filter(data => data !== undefined)
            )
            .subscribe(data => {
                this.closeModal();
                window.open(data.authorizationURI, '_blank');
            });
        if (this.currentOrgDetails && this.currentOrgDetails['id']) {
            this.getOrgDetails(this.currentOrgDetails);
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}

interface OrganizationNode {
    organization: Organization;

    nextNodes: OrganizationNode[];
}
